import { generateHref } from '@shared/utils/core/navigation';

export type ErrorModalAction = {
    href: string;
    label: string;
};

function getErrorId(error: unknown | unknown[]): string | undefined {
    if (Array.isArray(error)) {
        if (error.length !== 1) {
            return undefined;
        }

        return getErrorId(error[0]);
    }

    if (typeof error !== 'object' || !error) {
        return undefined;
    }

    return typeof (error as { data?: { errorId?: unknown } }).data?.errorId === 'string'
        ? ((error as { data?: { errorId?: string } }).data?.errorId as string)
        : undefined;
}

export function getErrorModalAction({
    error,
    baseUrl,
    canOpenSettings,
    orgId,
}: {
    error: unknown | unknown[];
    baseUrl?: string;
    canOpenSettings: boolean;
    orgId?: bigint;
}): ErrorModalAction | null {
    if (!canOpenSettings || orgId === undefined || !baseUrl) {
        return null;
    }

    const errorId = getErrorId(error);

    if (errorId !== 'email.domainNotVerified') {
        return null;
    }

    return {
        href: generateHref({
            baseUrl,
            to: '/console/$orgId/configuration/org-settings/system',
            params: { orgId },
        }),
        label: 'Open Email settings',
    };
}
